export const TYPE_ERROR = 'error' as const;
export const TYPE_PROGRESS = 'progress' as const;
export const TYPE_SUCCESS = 'success' as const;
